import { render, staticRenderFns } from "./typo.vue?vue&type=template&id=05eeae70&scoped=true&"
import script from "./typo.vue?vue&type=script&lang=js&"
export * from "./typo.vue?vue&type=script&lang=js&"
import style0 from "./typo.vue?vue&type=style&index=0&id=05eeae70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05eeae70",
  null
  
)

component.options.__file = "typo.vue"
export default component.exports